<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icons/arrow-down-bold">
      <path
        id="Union"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.29297 11.9442L11.793 19.4443L12.5001 20.1514L13.2072 19.4443L20.7072 11.9442L19.293 10.53L13.5001 16.3229L13.5001 4.08557L11.5001 4.08557L11.5001 16.3229L5.70718 10.53L4.29297 11.9442Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
